import { ElementType, FunctionComponent, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { TabsProps } from '@mui/material/Tabs';
import last from 'lodash/last';
import some from 'lodash/some';
import split from 'lodash/split';

import { useOnFeatureClearingStates } from '../../../../shared/hooks/use-on-feature-clearing-states/use-on-feature-clearing-states.hook';
import NavTab from '../../../shared/components/nav-tab/NavTab';
import SnackBarContextProvider from '../../../shared/components/snack-bar-context/SnackBarContext';
import Paper from '../../../shared/components/ui/Paper/Paper';
import Typography from '../../../shared/components/ui/Typography/Typography';
import { useQueryParams } from '../../../shared/hooks/use-query-params/use-query-params.hook';
import { clearReviewsFilters } from '../RatingsAndReviews/store/slices/slices/reviews.slice';

const AppCreateLayout: FunctionComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = useQueryParams();
  const isOnCreate = location.pathname.startsWith('/appstore/all-apps/create/');
  const appCreated = queryParams['appCreated'] === 1;

  useOnFeatureClearingStates([clearReviewsFilters()]);

  const tabs: TabsProps<ElementType>[] = [
    {
      label: 'Details',
      value: 'details',
      to: 'details',
    },
    {
      label: 'Releases',
      value: 'releases',
      to: isOnCreate ? 'details' : 'releases',
      sx: {
        ...(isOnCreate && {
          opacity: 0.5,
          pointerEvents: 'none',
        }),
      },
    },
    {
      label: 'Ratings & Reviews',
      value: 'ratings-reviews',
      to: 'ratings-reviews',
    },
    {
      label: 'Statistics',
      value: 'statistics',
      to: 'statistics',
    },
  ];

  useEffect(() => {
    const pathValue = last(split(location.pathname, '/'));
    if (
      !some(tabs, tab => {
        return tab.to === pathValue;
      })
    ) {
      navigate(tabs[0]?.to);
    }
  }, []);

  return (
    <>
      <SnackBarContextProvider>
        <Typography
          variant="h1"
          sx={{
            fontSize: '32px',
            fontWeight: 300,
            marginTop: '54px',
            marginBottom: '32px',
          }}
          data-testid="app-create-edit-layout"
        >
          {isOnCreate || appCreated ? 'Add New App' : 'Edit App'}
        </Typography>

        <Paper
          sx={[
            {
              boxShadow: 'none',
              borderRadius: 0,
              transition: 'none',
              padding: 0,
            },
            {
              a: {
                width: '25%',
              },
            },
          ]}
        >
          <NavTab tabs={tabs} />
        </Paper>
        <Outlet />
      </SnackBarContextProvider>
    </>
  );
};

export default AppCreateLayout;
